<div class="nav-bar-logo">
    <div class="nav-bar-logo__inner">
        <button (click)="handleLogoClick($event)" title="Home" class="nav-bar-logo__link">
            <img width="103" height="23" directive-image-preload url="/assets/images/logo.svg" alt="Home" class="nav-bar-logo__img">
        </button>
    </div>
</div>
